import { messageCenterDotAtom } from '@/common/recoil/atom'
import { commonRequest } from '@/common/utils/request'
import { getIsOrderManager, getLoginShopid, safeParse } from '@RootCommon/utils'
import { useRecoilState } from 'recoil'

const isOrderManager = getIsOrderManager()

export default function () {
  const [messageDot, setMessageDot] = useRecoilState(messageCenterDotAtom)

  // 更新消息铃铛红点信息，依赖门店信息就绪
  const updateMessageDotByCategoryList = () => {
    commonRequest
      .get('/api/msgcenter/inbox/getcategorylist', {
        params: {
          shopId: getLoginShopid(),
        },
        autoToast: !isOrderManager,
      })
      .then(r => {
        setMessageDot(r.totalUnreadCount > 0)
      })
      .catch(e => {
        console.log(e)
      })
  }

  return {
    messageDot,
    updateMessageDotByCategoryList,
  }
}
